<template>
  <div class="pageContent">
    <Loading
      v-if="waiting"
      class="loading"
    />

    <div v-else>
      <b-modal id="OccurrenceDetails" size="xl" hide-footer>
        <div slot="modal-title" class="d-flex align-items-center">
          <img 
            id="occurrence-icon"
            src="../../assets/circular138.png" 
            alt="salvar_ocorrencia" 
          >
          EDITOR DE OCORRÊNCIA
        </div>
        <OccurrenceDetails :nodeSelected="nodeSelected.occurrenceSelected" :loadTree="loadOccurrencesTree"/>
      </b-modal>

      <div :class="[{dashSectionWithModal: dashSectionWithModal, dashSectionWithoutModal: dashSectionWithoutModal}]">
        <div
          :class="[{headerDash: true, headerDashPositionWithoutModal: headerDashPositionWithoutModal, headerDashPositionWithModal: headerDashPositionWithModal}]"
          id="hd">
          <div class="col1Header">
            DESCRIÇÃO
          </div>
          <div class="col2Header">
            DATA
          </div>
          <div class="col3Header">
            RESPONSÁVEL
          </div>
          <div class="col4Header">
            PRAZO
          </div>
          <div class="col5Header">
            INDICADOR RELACIONADO
          </div>
          <div class="col6Header">
            STATUS
          </div>
        </div>

        <div class="mt-2" id="filter-box">
          <label for="filter-tree">Filtro: </label>
          <input type="text" id="filter-tree" class="ml-1" v-model="treeFilter">
          <img v-print="printObj" class="ml-2 printer-button" src="@/assets/printer.png" alt="Imprimir" />
        </div>

        <tree id="printMe" ref="tree" :data="items" @node:dblclick="onNodeSelect" :options="treeOptions"
          :filter="treeFilter">
          <span class="tree-text grid" slot-scope="{ node }">

            <template v-if="!node.hasChildren()">
              <span class="tree-text rootStyle">
                <div class="col1"> <b>{{node.data.title}}</b> {{node.data.description}} </div>
                <div class="col2"> {{node.data.baseDate | dateBR}} </div>
                <div class="col3"> {{node.data.responsibleName}} </div>
                <div class="col4" v-if="node.data.statusId == 1"> {{node.data.deadlineInDays}} </div>
                <div class="col4" v-if="node.data.statusId != 1"> - </div>
                <div class="col5"> {{node.data.indicatorName}} </div>
                <div class="col6">
                  <SemaforoVerde v-if="node.data.statusId == 1 && node.data.deadlineInDays >= 0" />
                  <SemaforoVermelho v-else />
                </div>
              </span>
            </template>

            <template v-else>
              <span class="tree-text rootStyle" v-if="node.data.root == 1">
                <div class="col1">
                  <!-- <b>{{node.data.title}}{{node.children.filter((x)=> x.state.visible == 'false').length}}<span v-if="node.data.title == 'GDI' || node.data.title == 'PGDI'"> - Total de ocorrências: {{node.children.length}}</span></b>                   -->
                  <b>{{node.data.title}}<span v-if="node.data.title == 'GDI' || node.data.title == 'PGDI'"> - Total de
                      ocorrências: {{node.children.length}}</span></b>
                </div>
                <template v-if="node.data.headerDate">
                  <div class="col2 root-header"><b>{{node.data.headerDate}}</b></div>
                  <div class="col3 root-header"><b>{{node.data.headerResp}}</b></div>
                  <div class="col4 root-header"><b>{{node.data.headerDead}}</b></div>
                  <div class="col5 root-header"><b>{{node.data.headerIndi}}</b></div>
                  <div class="col6 root-header"><b>{{node.data.headerStat}}</b></div>
                </template>
              </span>
            </template>
          </span>
        </tree>

      </div>
    </div>
  </div>
</template> 

<script>
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { urlMainAPI } from "@/global";
import Tree from "liquor-tree";
import Loading from "@/components/template/Loading.vue";
import OccurrenceDetails from "@/components/occurrencetree/modal/OccurrenceDetails.vue";
import SemaforoVerde from "@/components/utils/SemaforoVerde.vue";
import SemaforoVermelho from "@/components/utils/SemaforoVermelho.vue";

export default {
  components: { Tree, Loading, OccurrenceDetails, SemaforoVerde, SemaforoVermelho },

  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ");
      dateBr = info[0];
      if (dateBr == "Invalid") {
        return "";
      }
      else {
        return (dateBr);
      }
    },
  },

  data() {
    return {
      items: null,
      treeFilter: '',
      printObj: {
        id: "printMe",
        popTitle: 'Relatório de ocorrências',
        extraHead: `
        <div style="text-align: center">
          <h3>RELATÓRIO DE OCORRÊNCIAS</h3>
        </div>
        `,
      },
      treeOptions: {
        filter: {
          emptyText: 'Sem resultados!',
          plainList: false,
          showChildren: true,
          matcher(query, node) {
            return new RegExp(query, 'i').test(node.data.title) ||
              new RegExp(query, 'i').test(node.data.description) ||
              new RegExp(query, 'i').test(node.data.responsibleName) ||
              new RegExp(query, 'i').test(node.data.indicatorName) ||
              new RegExp(query.split(" ")[0].split("/").reverse().join("-"), 'i').test(node.data.baseDate)
          }
        },
      },
      waiting: false,
      showDetails: false,
      headerDashPositionWithModal: false,
      headerDashPositionWithoutModal: true,
      dashSectionWithoutModal: true,
      dashSectionWithModal: false,
      nodeSelected: {
        keySelect: 0,
        occurrenceSelected: "",
      },
    }
  },

  computed: {
    countOccurrence(children) {
      var total = 0
      Object.keys[children].forEach((item) => {
        if (item.state.visible == true)
          total = total++
      })
      return total
    },
  },

  watch: {

  },
  created() {
    this.loadOccurrencesTree();
  },

  methods: {
    onNodeSelect(node) {
      if (!node.data.root) {
        this.showDetails = true;
        // this.headerDashPositionWithModal = true;
        // this.headerDashPositionWithoutModal = false;
        // this.dashSectionWithoutModal = false;
        // this.dashSectionWithModal = true;
        this.$bvModal.show("OccurrenceDetails");
        this.nodeSelected.occurrenceSelected = node.data;
      }
    },

    onCloseModal() {
      this.showDetails = false;
      this.headerDashPositionWithModal = false;
      this.headerDashPositionWithoutModal = true;
      this.dashSectionWithoutModal = true;
      this.dashSectionWithModal = false;
    },

    loadOccurrencesTree() {
      this.treeFilter = ""
      const url = `${urlMainAPI}/getoccurrencetree`;
      this.waiting = true;
      axios
        .get(url)
        .then((res) => {
          this.items = res.data.occurrencesTree;
          this.waiting = false;
        })
        .catch();
    },
  },
};
</script>

<style scoped>
#occurrence-icon {
  width: 33px;
  height: 33px;
  margin-right: 10px;
}

.printer-button {
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.col1Header {
  max-width: 564px;
  text-align: center;
}

.col2Header {
  position: absolute;
  left: 600px;
  padding-left: 0px;
  min-width: 100px;
  text-align: center;
}

.col3Header {
  position: absolute;
  left: 720px;
  padding-left: 0px;
  min-width: 200px;
  text-align: center;
}

.col4Header {
  position: absolute;
  left: 920px;
  padding-left: 0px;
  min-width: 80px;
  text-align: center;
}

.col5Header {
  position: absolute;
  left: 1000px;
  padding-left: 0px;
  min-width: 300px;
  text-align: center;
}

.col6Header {
  position: absolute;
  left: 1300px;
  padding-left: 0px;
  min-width: 100px;
  text-align: center;
}

.loading {
  position: absolute;
  top: Calc(50% - 128px);
  left: Calc(50% - 128px);
}

.tree-text {
  display: grid;
  font-family: Arial;
  font-size: 14pt;
  margin-right: 40px;
}

.rootStyle {
  font-weight: 500;
}

.col1 {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col2 {
  position: absolute;
  left: 600px;
  min-width: 100px;
  text-align: center;
}

.col3 {
  position: absolute;
  left: 720px;
  min-width: 200px;
  max-width: 200px;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col4 {
  position: absolute;
  left: 920px;
  min-width: 80px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col5 {
  position: absolute;
  left: 1000px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col6 {
  position: absolute;
  left: 1300px;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.graphSection {
  position: fixed;
  top: 100px;
  z-index: 2;
  background-color: white;
  width: 98%;
  height: 320px;
}


.headerDash {
  display: grid;
  background-color: rgba(0, 0, 0);
  color: white;
  height: 24px;
}

.dashSectionWithModal {
  position: relative;
  top: 330px;
  width: 100%;
  overflow: auto;
}

.dashSectionWithoutModal {
  position: relative;
  top: 10px;
  width: 100%;
  overflow: auto;
}

.headerDashPositionWithModal {
  position: fixed;
  top: 420px;
  z-index: 1;
  width: 98%;
  overflow: hidden;
}

.headerDashPositionWithoutModal {
  position: fixed;
  top: 101px;
  z-index: 1;
  width: 98%;
}

#filter-tree {
  border: 2px solid black;
  border-radius: 4px;
}

.root-header {
  display: none;
}

@media only screen and (max-width: 1199px) {
  #hd {
    display: none;
  }

  .root-header {
    display: inline-block;
  }

  .dashSectionWithModal {
    top: 320px;
  }
}

@media only screen and (max-width: 1160px) {
  .graphSection {
    top: 140px;
  }

}

@media only screen and (max-width: 740px) {
  .graphSection {
    height: 330px;
  }

  .dashSectionWithModal {
    top: 330px;
  }

}
</style>


